export default __webpack_public_path__ + "static/media/faci09.62293dcf.jpg";